import { CaseHistoryContainer } from 'App/containers'

export const CaseHistory = () => <CaseHistoryContainer />
